var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.348 26h3.484V12.819H8.348V26zM10.09 7C8.93 7 8 7.95 8 9.137c0 1.188.929 2.138 2.09 2.138 1.162 0 2.09-.95 2.09-2.138C12.18 7.95 11.253 7 10.09 7zm7.665 7.838v-2.02H14.27V26h3.484v-6.769c0-3.8 4.761-4.037 4.761 0V26H26v-8.075c0-6.413-6.62-6.175-8.245-3.088z",
    fill: "#fff"
  })));
}

export default SvgLinkedIn;